import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../shared/config/routes';
import { useCookie } from '../context/CookieConsentContext';

export default function CookieConsentModal() {
  const { showModal, openModal, closeModal } = useCookie();

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      openModal();
    }
  }, [openModal]);

  function handleAcknowledge() {
    localStorage.setItem('cookieConsent', 'acknowledged');
    closeModal();
  }

  if (!showModal) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-xl shadow-lg max-w-md text-center">
        <h2 className="text-xl font-bold mb-4">Información sobre cookies y privacidad</h2>
        <p className="mb-4 text-sm">
          Este sitio utiliza almacenamiento técnico necesario para recordar preferencias básicas. Si en el futuro se incorporan cookies analíticas, publicitarias o de personalización no esenciales, se solicitará consentimiento específico antes de activarlas.
        </p>
        <div className="flex justify-center gap-4">
          <button onClick={handleAcknowledge} className="bg-slate-900 text-white px-4 py-2 rounded-lg">Entendido</button>
          <Link
            to={ROUTES.cookiesPolicy}
            onClick={() => localStorage.setItem('cookieConsent', 'acknowledged')}
            className="bg-slate-100 text-slate-800 px-4 py-2 rounded-lg"
          >
            Ver política
          </Link>
        </div>
      </div>
    </div>
  );
}
